import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class APDHeader  {
    _originalTypeClassName = "zERP.BO.APDHeader";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
APDHeader.translate = translateService;
}
this.Id = null;
this.RecordType = null;
this.PronouncementType = null;
this.LocalSubmissionDirection = null;
this.LocalDirection = null;
this.CompanyLastName = null;
this.FirstName = null;
this.FatherName = null;
this.AME = null;
this.AFM = null;
this.ReferenceMonth = null;
this.ReferenceYear = null;
this.TotalInsuranceDays = null;
this.TotalSalary = null;
this.TotalContributionsPayable = null;
this.SubmissionDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
RecordType:any;
PronouncementType:any;
LocalSubmissionDirection:any;
LocalDirection:any;
CompanyLastName:any;
FirstName:any;
FatherName:any;
AME:any;
AFM:any;
ReferenceMonth:any;
ReferenceYear:any;
TotalInsuranceDays:any;
TotalSalary:any;
TotalContributionsPayable:any;
SubmissionDate:any;
Address:any;
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}